/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import * as StateNames from 'state-names';
import './item-detail-page-header.less';

/**
 * Set of state names where the metrics selector should be seen.
 */
const showMetricsSelectorSet = new Set([
    StateNames.GSLBSERVICE_DETAIL_FQDN_LIST,
    StateNames.VS_DETAIL_ANALYTICS,
    StateNames.VS_DETAIL_SECURITY,
    StateNames.VS_DETAIL_DNS_RECORDS,
    StateNames.POOL_DETAIL_ANALYTICS,
    StateNames.POOL_SERVER_LIST,
]);

/**
 * Set of state names where the timeframe selector should be seen.
 */
const showTimeframeSelectorSet = new Set([
    StateNames.GSLBSERVICE_DETAIL_FQDN_LIST,
    StateNames.GSLBSERVICE_DETAIL_EVENTS,
    StateNames.VS_DETAIL_ANALYTICS,
    StateNames.VS_DETAIL_VS_LOGS,
    StateNames.VS_DETAIL_SECURITY,
    StateNames.VS_DETAIL_EVENTS,
    StateNames.VS_DETAIL_ALERTS,
    StateNames.VS_DETAIL_DNS_RECORDS,
    StateNames.VS_DETAIL_SECURITY_SECURITY_DASHBOARD,
    StateNames.VS_DETAIL_SECURITY_LEGACY_SECURITY,
    StateNames.VS_DETAIL_TOPOLOGY,
    StateNames.POOL_DETAIL_ANALYTICS,
    StateNames.POOL_DETAIL_POOL_LOGS,
    StateNames.POOL_SERVER_LIST,
    StateNames.POOL_DETAIL_EVENTS,
    StateNames.POOL_DETAIL_ALERTS,
]);

/**
 * @ngdoc component
 * @name  itemDetailPageHeader
 * @param {VirtualService|GslbService} item
 * @param {string} itemType - For now we need itemType to be set to use the right template for
 *     this component. For now only "vs", "gslbservice", and "pool" are supported.
 * @description
 *
 *     Item detail page header component. Consists of subheader that includes the unit info and
 *     healthscore along with nav bar for navigating child pages.
 *
 *     Tricky (workaround) part is the flexible width based on page content (sidebar).
 */
class ItemDetailPageHeaderController {
    constructor($scope, $elem, $state, $transitions, myAccount) {
        this.$scope_ = $scope;
        this.$elem_ = $elem;
        this.$state_ = $state;
        this.$transitions_ = $transitions;
        this.myAccount_ = myAccount;

        this.setSelectorsVisibility();

        this.destroyTransitionListener = this.$transitions_.onSuccess({}, () => {
            this.setSelectorsVisibility();
        });
    }

    $onDestroy() {
        this.destroyTransitionListener();
    }

    /**
     * Sets flags to determine if the timeframe and metrics selectors should be visible.
     */
    setSelectorsVisibility() {
        const { name: stateName } = this.$state_.$current;

        this.showTimeframeSelector = showTimeframeSelectorSet.has(stateName);
        this.showMetricSelector = showMetricsSelectorSet.has(stateName);
    }

    /**
     * Returns true if current details child page is using sidebar.
     * @return {boolean}
     * @private
     */
    hasSidebar_() {
        return this.$state_.current.data && !!this.$state_.current.data.hasSidebar || false;
    }
}

ItemDetailPageHeaderController.$inject = [
    '$scope',
    '$element',
    '$state',
    '$transitions',
    'myAccount',
];

const templateUrl = function({ itemType }) {
    const
        folder = 'src/components/common/item-detail-page-header/',
        suffix = '-detail-page-header.html';

    if (!itemType) {
        console.error('Can\'t use itemDetailPageHeader wo setting the item type');
    }

    return folder + itemType + suffix;
};

templateUrl.$inject = ['$attrs'];

angular.module('aviApp').component('itemDetailPageHeader', {
    bindings: {
        item: '<',
        itemType: '@',
    },
    controller: ItemDetailPageHeaderController,
    templateUrl,
});
